export default __webpack_public_path__ + "c952cd84f55f9b391c8b0bdf0c9a2557.svg";